export const GET_IP_ADDRESS = "https://api.ipify.org/?format=json"
export const SLACK = "https://hooks.slack.com/services/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";
export const ZIP_CODE_API = "https://api.zippopotam.us/us/";
export const PABBLY = "https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjUwNTZjMDYzNTA0M2M1MjY1NTUzNTUxM2Ii_pc"

export const APIS = { GET_IP_ADDRESS, SLACK, ZIP_CODE_API, PABBLY };